import { render, staticRenderFns } from "./modalDuplicarComision.vue?vue&type=template&id=80327626"
import script from "./modalDuplicarComision.vue?vue&type=script&lang=js"
export * from "./modalDuplicarComision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports